// Stripe.js initialization for Sunlight Grounds Care Client Portal
// This file handles all Stripe browser-side operations

import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with publishable key
// The secret key is ONLY on the backend - never put it here
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_placeholder');

export default stripePromise;

// Helper to open Stripe Checkout
export const openCheckoutSession = async (checkoutUrl) => {
  if (checkoutUrl) {
    window.open(checkoutUrl, '_blank');
  }
};

// Helper to open Stripe Customer Portal
export const openCustomerPortal = async (portalUrl) => {
  if (portalUrl) {
    window.open(portalUrl, '_blank');
  }
};
